var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmmeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,18.8c-16.8,0-30.6,13.3-31.2,30H5v2.5h13.8c0.7,16.7,14.4,30,31.2,30s30.6-13.3,31.2-30H95v-2.5H81.2  C80.6,32.1,66.8,18.8,50,18.8z M50,78.8c-15.9,0-28.8-12.9-28.8-28.8S34.1,21.3,50,21.3c15.9,0,28.8,12.9,28.8,28.8  S65.9,78.8,50,78.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3,60.9l2.2,1.2l4.6-8.4h13.8l4.6,8.4l2.2-1.2L50,36.2L36.3,60.9z M44.5,51.3l5.5-9.9l5.5,9.9H44.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmmeter);
export default __webpack_public_path__ + "static/media/ammeter.83b6c0ed.svg";
export { ForwardRef as ReactComponent };